/* eslint-disable */
// @ts-nocheck

import { cn } from '@/lib/utils'

import { BasicNomenclator } from '../../interfaces/ServerInterfaces'

interface CheckProps {
  data: BasicNomenclator[]
  selected: BasicNomenclator[]
  setSelected: Function
  displayCol?: boolean
  itemClassName?: string
}

export default function Checkbox({
  data,
  selected,
  setSelected,
  displayCol,
  itemClassName,
}: CheckProps) {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //@ts-ignore
    const currentValue = isNaN(e.target.value)
      ? e.target.value
      : Number(e.target.value)
    if (e.target.checked) {
      setSelected([
        ...selected,
        ...data.filter((item) => item.id === currentValue),
      ])
    } else {
      setSelected(
        selected.filter((item) => item.id !== currentValue),
        e.target.value
      )
    }
  }

  // Función para manejar el clic en el div contenedor
  const handleDivClick = (item: BasicNomenclator) => {
    // Solo permitir el clic si el ítem no está deshabilitado
    //@ts-ignore
    if (item.disabled) return

    const isChecked =
      selected.filter((check) => check.id === item.id).length !== 0

    if (isChecked) {
      setSelected(selected.filter((check) => check.id !== item.id))
    } else {
      setSelected([...selected, item])
    }
  }

  return (
    <fieldset>
      <div className={`${displayCol ? 'flex-col' : 'grid grid-cols-4 gap-5'}`}>
        {data.map((item, idx) => {
          // Crear un ID único para cada checkbox
          const checkboxId = `checkbox-${item.id}-${idx}`
          const isChecked =
            selected.filter((check) => check.id === item.id).length !== 0

          return (
            <div
              className={cn(
                'flex items-start p-2',
                //@ts-ignore
                !item.disabled && 'cursor-pointer',
                itemClassName
              )}
              key={idx}
              onClick={() => handleDivClick(item)}
            >
              <div className="flex h-6 items-center">
                <input
                  checked={isChecked}
                  className={`h-4 w-4 rounded border-gray-300 focus:bg-transparent focus:ring-transparent ${
                    //@ts-ignore
                    item.disabled ? 'text-slate-400' : 'text-slate-600'
                  }`}
                  disabled={Boolean(item.disabled)}
                  id={checkboxId}
                  name={item.name}
                  onChange={(e) => onChange(e)}
                  onClick={(e) => e.stopPropagation()}
                  // Evitar la propagación para prevenir comportamiento duplicado
                  type="checkbox"
                  //@ts-ignore
                  value={item.id}
                />
              </div>
              <div className="text-md ml-2 leading-6">
                <label
                  className={`font-medium ${
                    //@ts-ignore
                    item.disabled ? 'text-slate-400' : 'text-gray-700'
                  }`}
                  htmlFor={checkboxId}
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* @ts-ignore */}
                  {item.label || item.name}
                </label>{' '}
              </div>
            </div>
          )
        })}
      </div>
    </fieldset>
  )
}
